import React, { useEffect } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { fetchAuthUser } from "../redux/actions/api_auth";
import "../assets/styles/Theme.scss";

const LayoutIndex = ({ children, auth, fetchAuthUser }) => {
  useEffect(() => {
    if (auth.token && (!auth.isAuthenticated || !auth.user)) {
      fetchAuthUser();
    }
  }, [fetchAuthUser, auth.token, auth.isAuthenticated, auth.user]);

  return <React.Fragment>{children}</React.Fragment>;
};

const mapStateToProps = (state) => ({
  auth: state.api_auth,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAuthUser: () => dispatch(fetchAuthUser()),
});

LayoutIndex.propTypes = {
  children: Proptypes.element.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutIndex);
